import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";
import moment from "moment";

class MarketSaleRow extends Component {
  formatAddressName(address, agentListing) {
    function capitalizeFirstLetter(word) {
      if ((word && word.length < 5) || (word && word.includes("#"))) {
        return word;
      } else {
        word = word.toLowerCase();
        const firstLetter = word.charAt(0);
        const firstLetterCap = firstLetter.toUpperCase();
        const remainingLetters = word.slice(1);
        const capitalizedWord = firstLetterCap + remainingLetters;
        return capitalizedWord;
      }
    }

    let split = address.split(" ");
    let mappedSplit = split.map((name) => {
      let isAllUpperCase = name === name.toUpperCase();
      if (isAllUpperCase) {
        return capitalizeFirstLetter(name);
      }
      return name;
    });
    return mappedSplit.join(" ");
  }
  getMonthAndYearString = (inputTime) => {
    try {
      let month = moment(inputTime).format("MMM");
      let day = moment(inputTime).format("D");
      let year = moment(inputTime).format("YY");
      return (
        <div className="date-td">
          <div>{month}</div>
          <div>{day},</div>
          <div>{year}</div>
        </div>
      );
      // return moment(inputTime).format("MMM D, YYYY");
    } catch (err) {
      return "";
    }
  };

  calculatePricePerSqft(calculation, saleP, sqft) {
    if (calculation === "-") {
      let res = Math.round(saleP / sqft);
      return res.toLocaleString();
    } else {
      return Math.round(calculation).toLocaleString();
    }
  }

  render() {
    const { formatBaths, propTypeAcronym, shortenStatus } = propertyUtil;
    const {
      solds,
      mlsAreaID,
      older,
      isSingleTable,
      agentData,
      hidePropertyTypeColumn,
      hasAllActiveProperties,
    } = this.props;
    const { listgenUserID } = agentData;
    let isGailPearl = listgenUserID === "103455";
    let isCountryClubGate = mlsAreaID === "132" ? true : false;
    const listMap =
      solds &&
      solds.map((list, i) => {
        let isAgentListing =
          list.isAgentFiltered === true || list.status === "Coming Soon";

        if (
          mlsAreaID === "SCL-233E" &&
          list.streetNumber === "773" &&
          list.streetName === "Loma Verde" &&
          list.unitNumber === "A"
        ) {
          list.propertyType = "Townhouse";
        }
        if (
          (listgenUserID === "109954" &&
            list.status === "Coming Soon" &&
            list.streetName === "Blackstone Dr") ||
          (listgenUserID === "109938" &&
            list.status === "Coming Soon" &&
            list.streetNumber === "323" &&
            list.streetName === "Laurel Dr")
        ) {
          isAgentListing = false;
        }
        if (isGailPearl) {
          isAgentListing = false;
          if (list.streetName === "Moreton Bay" && list.streetSuffix === "-") {
            list.streetSuffix = "Lane";
          }
        }
        if (
          list.streetNumber === "51" &&
          list.streetName === "Six Flags" &&
          list.streetSuffix === "Cir" &&
          listgenUserID === "100661"
        ) {
          isAgentListing = true;
        }

        if (
          listgenUserID === "102627" &&
          list.streetNumber === "4840" &&
          list.streetName === "Anna" &&
          list.streetSuffix === "Dr"
        ) {
          isAgentListing = false;
        }

        if (
          listgenUserID === "107251" &&
          list.streetNumber === "4231" &&
          list.streetName === "Jensen St" &&
          list.status === "Sold"
        ) {
          isAgentListing = true;
        }
        let extraDisclaimer = false;
        if (
          mlsAreaID === "SMA-470" &&
          list.streetNumber === "2533" &&
          list.streetName === "Hayward" &&
          list.streetSuffix === "Dr"
        ) {
          extraDisclaimer = true;
        }
        let isAnnetteVait = listgenUserID === "101001";
        let isKristinArntz = listgenUserID === "100462";
        let isShawnaSpaulding = listgenUserID === "100210";
        let isFlashberger = listgenUserID === "107253";
        let showAddressNumber =
          list.status === "Sold" ||
          isAgentListing ||
          isAnnetteVait ||
          isKristinArntz ||
          isGailPearl ||
          isFlashberger ||
          isShawnaSpaulding ||
          listgenUserID === "109954";
        let hasUnitNum =
          !isCountryClubGate &&
          (list.propertyType === "Townhouse" ||
            list.propertyType === "Condominium" ||
            list.propertyType === "Condo/Co-Op") &&
          list.unitNumber !== "-";
        let addressName = "";
        let isJulieFlouty651Columbia =
          listgenUserID === "106421" &&
          list.streetNumber === "651" &&
          list.streetName === "Columbia";
        if (isJulieFlouty651Columbia) {
          showAddressNumber = false;
        }
        if (
          list.streetNumber !== "-" &&
          list.streetNumber !== "0" &&
          list.streetNumber !== "." &&
          showAddressNumber &&
          !isJulieFlouty651Columbia
        ) {
          addressName += list.streetNumber;
        }
        if (
          isGailPearl == "x" &&
          list.streetNumber === "x5800" &&
          list.streetName === "Encina Road #3"
        ) {
          addressName += ` Encina, #3`;
        } else {
          addressName += ` ${list.streetName}`;
        }
        if (list.streetSuffix && list.streetSuffix !== "-") {
          addressName += ` ${list.streetSuffix}`;
        }
        if (hasUnitNum && showAddressNumber) {
          let comma = ",";
          if (isGailPearl) {
            comma = "";
          }
          if (list.unitNumber.includes("Unit")) {
            if (
              isGailPearl == "x" &&
              list.streetName == "xEncina" &&
              list.streetNumber === "5940" &&
              list.unitNumber == "Unit 1"
            ) {
              addressName += ", #1";
            } else {
              addressName += `${comma} ${list.unitNumber}`;
            }
          } else if (list.unitNumber.includes("#")) {
            addressName += `${comma} ${list.unitNumber}`;
          } else {
            addressName += `${comma} #${list.unitNumber}`;
          }
        }
        if (
          listgenUserID === "110007" &&
          list.streetName.includes("Prospect") &&
          list.streetNumber === "342"
        ) {
          addressName = `342 W. Prospect Ave`;
        }
        let soldDisclaimer = false;

        let domDisclaimer = false;
        if (mlsAreaID === "SMA-470") {
          let has1556BernalAve =
            list.streetNumber === "1556" &&
            list.streetName === "Bernal" &&
            list.streetSuffix === "Ave";

          if (has1556BernalAve) {
            domDisclaimer = true;
          }
        }
        let addressSize = addressName.length > 25 ? "smaller-row-address" : "";
        if (
          isGailPearl &&
          list.streetNumber === "250" &&
          list.streetName === "N, Fairview Avenue #6"
        ) {
          addressName = `250 N. Fairview Avenue #6`;
        } else if (
          isGailPearl &&
          list.streetNumber === "320" &&
          list.streetName === "Fairview"
        ) {
          addressName = `320 Fairview Avenue #5`;
        } else if (
          isGailPearl &&
          list.streetNumber === "340" &&
          list.streetName === "Fairview"
        ) {
          addressName = `340 Fairview Avenue #2`;
        }
        let coListingDisclaimer = false;
        let coListing710FrenchmansDisclaimer = false;
        if (
          listgenUserID === "102527" &&
          list.streetNumber === "710" &&
          list.streetName === "Frenchmans"
        ) {
          coListing710FrenchmansDisclaimer = true;
        }
        if (
          listgenUserID === "102527" &&
          list.streetNumber === "855" &&
          list.streetName === "Allardice"
        ) {
          coListing710FrenchmansDisclaimer = true;
        }
        let buyersAgentDisclaimer;
        if (
          mlsAreaID === "SMA-429" &&
          list.streetNumber === "721" &&
          list.streetName === "Linda" &&
          list.streetSuffix === "CT"
        ) {
          buyersAgentDisclaimer = true;
        }
        let useComingSoon;
        let is3650LockeCt =
          list.streetNumber === "3650" &&
          list.streetName === "Locke Ct" &&
          listgenUserID === "107253";
        if (
          listgenUserID === "107253" &&
          list.streetName === "Benedict Ct" &&
          list.streetNumber === "1398"
        ) {
          console.log("inside", list);
          list.bedBaths = "6/5.5";
        }
        let useDaysOnMarketDash = false;

        if (isGailPearl) {
          addressName = addressName.replace(/\bLn\b/g, "Lane");
          addressName = addressName.replace(/\bRd\b/g, "Road");
        }
        return (
          <tr
            key={`${list.address} ${list.listPrice} ${list.saleDate} ${i}`}
            className={`${list.status && list.status.toLowerCase()} ${
              older ? "presolds-row" : "recent-row"
            } ${isSingleTable ? "single-table-row" : ""} ${
              isAgentListing ? "highlight-agent-listing" : ""
            }`}
          >
            {useComingSoon ||
            list.status === "Coming Soon" ||
            list.status === "Active - Coming Soon" ? (
              <td
                // className={`status-text`}
                className={`status-text coming`}
                align="left"
              >
                {(list.isOffMarketSale === "1" || soldDisclaimer) && (
                  <strong className="off-market-asterisk">*</strong>
                )}
                <p>
                  {domDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">* </strong>
                  )}
                  {extraDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">** </strong>
                  )}
                </p>
                <div>
                  <p>Coming</p>
                  <p>Soon</p>
                </div>
              </td>
            ) : (
              <td
                // className={`status-text`}
                className={`status-text ${
                  list.status && list.status.toLowerCase()
                }`}
                align="left"
              >
                <p>
                  {(list.isOffMarketSale === "1" || soldDisclaimer) && (
                    <strong className="off-market-asterisk">*</strong>
                  )}
                  {coListingDisclaimer && (
                    <strong className="extra-disclaimer-cl">cl </strong>
                  )}
                  {coListing710FrenchmansDisclaimer && (
                    <strong
                      className={`extra-disclaimer-star-cl ${list.status}-disclaimer`}
                    >
                      *cl{" "}
                    </strong>
                  )}

                  {buyersAgentDisclaimer && (
                    <strong
                      className={`extra-disclaimer-asterisk ${list.status}-extra-asterisk`}
                    >
                      *{" "}
                    </strong>
                  )}
                  {domDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">* </strong>
                  )}
                  {extraDisclaimer && (
                    <strong className="extra-disclaimer-asterisk">** </strong>
                  )}
                  {shortenStatus(list.status, "pendingOnly", true)}
                </p>
              </td>
            )}
            {(hasAllActiveProperties ? list.listDate : list.saleDate) ===
            "-" ? (
              <td></td>
            ) : (
              <td className="market-table-sale-date-row">
                {this.getMonthAndYearString(
                  hasAllActiveProperties ? list.listDate : list.saleDate,
                )}
              </td>
            )}
            {!hidePropertyTypeColumn && (
              <td className="prop-type-text">
                {propTypeAcronym(list.propertyType)}
              </td>
            )}
            <td className="address-td">
              <p className={addressSize}>
                {this.formatAddressName(addressName)}
              </p>
            </td>
            <td className="list-price-td">
              {list.status === "Coming Soon" &&
              listgenUserID !== "109954" &&
              listgenUserID !== "110007" ? (
                <div className="off-centered-dash-coming-soon">
                  <p>TBD</p>
                </div>
              ) : list.listPrice === "-" ? (
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              ) : (
                <div>
                  <p>$</p>
                  <p>{Number(list.listPrice).toLocaleString()}</p>
                </div>
              )}
            </td>
            <td className="sale-price-td">
              {listgenUserID === "100567" &&
              list.streetNumber === "3233" &&
              list.streetName === "Cliff" &&
              list.status === "Sold" ? (
                <div>
                  <p>$</p>
                  <p>11,000,000</p>
                </div>
              ) : list.salePrice === "-" ? (
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              ) : (
                <div>
                  <p>$</p>
                  <p>{Number(list.salePrice).toLocaleString()}</p>
                </div>
              )}
            </td>
            {list.isOffMarketSale === "1" &&
            (list.daysOnMarket === "0" || list.daysOnMarket === "-") ? (
              <td>
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              </td>
            ) : useDaysOnMarketDash ? (
              <td>
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              </td>
            ) : listgenUserID === "110007" && list.status === "Active" ? (
              <td>
                <div className="off-centered-dash">
                  <p>—</p>
                </div>
              </td>
            ) : (
              <td>{list.daysOnMarket}</td>
            )}
            <td>{formatBaths(list.bedBaths, true).bed}</td>
            <td>
              {is3650LockeCt
                ? "3.5"
                : formatBaths(list.bedBaths, true, true).bath}
            </td>
            <td>
              {list.squareFeet === "-" || list.squareFeet === "0" ? (
                <p>N/A</p>
              ) : (
                <p>{Math.round(list.squareFeet).toLocaleString()}</p>
              )}
            </td>
          </tr>
        );
      });
    return <tbody>{listMap}</tbody>;
  }
}

export default MarketSaleRow;
